import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {CreazionePraticaStoreService} from '../../services/creazione-pratica-store.service';
import {Petitum} from '../../../../../common/models/petitum';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import { filterElaborationEntityClean } from '../../utils/wizard-utils';
import { ElaborationEntityConstants } from '../../constants/elaboration-entity-constants';
import { ElaborationDocumentFilterEntity } from 'src/app/document-management/models/elaboration-doc-filter';
import { CreazionePraticaTipologicheService } from '../../services/creazione-pratica-tipologiche.service';
import { TipoPetitum } from 'src/app/common/models/tipologiche/tipo-petitum';
import { isPetitumValid } from '../../utils/petitum-utils';

declare var $: any;

@Component({
  selector: 'app-step-dati-economici',
  templateUrl: './step-dati-economici.component.html',
  styleUrls: ['./step-dati-economici.component.css']
})
export class StepDatiEconomiciComponent implements OnInit, OnDestroy {

  @Output() changeStep: EventEmitter<any> = new EventEmitter<any>()

  petitumFirstChanges= false;
  petitumLatestValidation = false;
  petitum: Petitum;
  isContinueEnabled: boolean = false
  private entities: ElaborationDocumentFilterEntity[];
  private componentDestroyed$: Subject<void> = new Subject<void>();
  tipiPetitum : TipoPetitum[] = [];
  constructor(
    private tipologicheService: CreazionePraticaTipologicheService,
    private creazionePraticaStoreService: CreazionePraticaStoreService,
  ) {
  }

  ngOnInit(): void {
    // console.log('[ngOnInit]', '---');

    this.tipologicheService.getTipiPetitum().subscribe(tipoPetitumArray => {
      if(tipoPetitumArray && tipoPetitumArray.length > 0){
        this.tipiPetitum = tipoPetitumArray;


        this.creazionePraticaStoreService.petitum$.subscribe(it => {
          
    
          this.getPetitumSuggested(it);
          
        });


      }
    });
    
  }

  private getPetitumSuggested(it: Petitum) {
    this.creazionePraticaStoreService.entities$.subscribe(entities => {
      if (entities) {
        this.entities = filterElaborationEntityClean(entities, [ElaborationEntityConstants.IMPORTO_ECONOMICO]);

        // console.log('[setPetitum]', '---', it);
        if (it) {
          // console.log('[setPetitum]', '---', "load");
          this.petitum = it;
        } else {
          let petitumSuggerito = new Petitum();

          if (this.entities && this.entities.length > 0) {
            let typeFiltered = this.tipiPetitum.filter(t => t.id === 'QUANTIFICABILE');
            if (typeFiltered && typeFiltered.length === 1) {
              petitumSuggerito.tipoPetitum = typeFiltered[0];
              //let entityFilter = this.entities[this.entities.length - 1];
              let entityFilter = this.entities[0];

              let importo = '';
              if (entityFilter.valore.length > 0) {
                let indexSpace = entityFilter.valore.indexOf(" ");
                importo = entityFilter.valore.substring(indexSpace + 1, entityFilter.valore.length);
                if(importo.includes(".") && importo.includes(",")){
                  importo = importo.replace(/\./g, "");
                }
              }
              petitumSuggerito.importoPetitum = importo;
            }
          }
          this.petitum = petitumSuggerito;
        }

      } else {
        this.petitum = new Petitum();
      }
    });
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
  }

  retrievePetitum(petitum : Petitum){
    this.petitum = petitum;
    this.petitum = this.formatImporto(this.petitum);
    this.creazionePraticaStoreService.setPetitum(this.petitum);
  }

  onValidPetitum(event: boolean) {
    this.isContinueEnabled = event;
    this.creazionePraticaStoreService.updateValidityPetitum(event)
  }

  onReset(): void {
    console.log('[onReset]', '---');
    this.getPetitumSuggested(undefined);
    if(!this.petitum){
      this.petitum = new Petitum();
    }
    this.petitum = this.formatImporto(this.petitum);
    this.creazionePraticaStoreService.setPetitum(this.petitum);
    this.creazionePraticaStoreService.updateValidityPetitum(isPetitumValid(this.petitum))
    this.isContinueEnabled = false;
  }

  onContinue(): void {
    this.petitum = this.formatImporto(this.petitum);
    this.creazionePraticaStoreService.setPetitum(this.petitum);
    this.changeStep.emit();
  }

  formatImporto(petitum:Petitum): Petitum{
    if(petitum.importoPetitum){
      let importoString = ''+petitum.importoPetitum;
      if(importoString.includes(".") && importoString.includes(",")){
        importoString = importoString.replace(/\./g, "");
        importoString = importoString.replace(/\,/g, ".");
      } else if(importoString.includes(",")){
        importoString = importoString.replace(/\,/g, ".");
      }
      petitum.importoPetitum = parseFloat(importoString);
    }
    return petitum;
  }
}
